import Grid from './GenericEditableGrid'

export default Grid
